import { useEffect, useRef } from "react";

// Run `effect` when this component unmounts.
//
// If `effect` changes from render to render, the latest value is the one that
// will be called on unmount.
export const useUnmountEffect = (effect: () => void): void => {
  const effectRef = useRef(effect);
  useEffect(() => {
    effectRef.current = effect;
  }, [effect]);

  useEffect(() => {
    return () => {
      effectRef.current();
    };
  }, []);
};
